import React from 'react';
import ReactDOM from 'react-dom';
import { normalizeMessageContentHtml } from '../../utils/fileUtils';

const CloseMeetingDialog = ({
  isOpen,
  onClose,
  onSubmit,
  meetingLabel,
  noteMessages = [],
  loading,
}) => {
  const hasNotes = noteMessages.length > 0;

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-black/55 backdrop-blur-[2px]">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-lg border border-gray-200 dark:border-gray-700 max-h-[90vh] flex flex-col">
        <div className="px-5 py-4 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Close call
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Review all call notes for {meetingLabel || 'this call'} before closing.
          </p>
        </div>

        <div className="px-5 py-4 overflow-y-auto flex-1 min-h-0">
          {hasNotes ? (
            <div className="space-y-3">
              {noteMessages.map((note) => (
                <div
                  key={note.id}
                  className="rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-900/50 p-3"
                >
                  <p className="text-sm font-semibold text-gray-900 dark:text-white mb-1">
                    {note.senderName || 'Participant'}
                    <span className="ml-2 text-xs font-normal text-gray-500 dark:text-gray-400">
                      {note.createdAt ? new Date(note.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                    </span>
                  </p>
                  <div
                    className="ql-editor-content text-sm text-gray-700 dark:text-gray-300"
                    dangerouslySetInnerHTML={{ __html: normalizeMessageContentHtml(note.content) }}
                  />
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500 dark:text-gray-400 italic">
              No call notes were added yet. You can still close the call.
            </p>
          )}
        </div>

        <div className="flex justify-end gap-2 px-5 py-4 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={loading}
            className="px-4 py-2 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 disabled:opacity-50 rounded-lg"
          >
            {loading ? 'Closing…' : 'Close call'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CloseMeetingDialog;
